// extracted by mini-css-extract-plugin
export default {"header":"header__n0TQl","bg":"bg__2sztf","content":"content__y1s-3","logo":"logo__ty5BH","active":"active__WcUMx"};